import { JetView } from 'webix-jet';
import { devConfig, countries, providersCasino, subprovidersCasino, gamesCasino, profile } from 'config/config';

/**
 * Class representing the FilterPartnersProductsView.
 * @extends JetView
 */
export default class FilterPartnersProductsView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._;
        const screen = this.app.config.size; // Get the current screen size
        const id_partner = this.getParam('partner', true); // Retrieve partner ID from parameters

        const left = {
            margin: 5,
            minWidth: 100,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text',
                            name: 'Id',
                            type: 'number',
                            label: "<span class='icon-drivers-license-o'></span>" + _('Id'),
                            labelPosition: 'top',
                            placeholder: _('Id'),
                            invalidMessage: _('Id is required'), // Validation message
                        },
                        {
                            view: 'combo',
                            name: 'ProviderId',
                            localId: 'provider:combo',
                            label: _('Proveedor'), // Provider label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: {
                                body: {
                                    dataFeed: function (text) {
                                        var vthis = this;
                                        if (text.length > 2) {
                                            // Trigger data fetch if input length is greater than 2
                                            webix
                                                .ajax()
                                                .headers({
                                                    'Content-type': 'application/json',
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'es/Select/ProvidersCasinoSelect',
                                                    '{"Filter":"' + text + '"}',
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            webix.message('Error! '); // Error message on failure
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            var resp = JSON.parse(text);
                                                            if (!resp.HasError) {
                                                                vthis.parse(resp.Data); // Parse and display data if no error
                                                            }
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            },
                        },
                        {
                            view: 'combo',
                            name: 'SubProviderId',
                            localId: 'subProvider:combo',
                            label: _('Sub Proveedor'), // Sub-provider label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: {
                                body: {
                                    dataFeed: function (text) {
                                        var vthis = this;
                                        if (text.length > 2) {
                                            // Trigger data fetch if input length is greater than 2
                                            webix
                                                .ajax()
                                                .headers({
                                                    'Content-type': 'application/json',
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'es/Select/SubProvidersCasinoSelect',
                                                    '{"Filter":"' + text + '"}',
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            webix.message('Error! '); // Error message on failure
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            var resp = JSON.parse(text);
                                                            if (!resp.HasError) {
                                                                vthis.parse(resp.Data); // Parse and display data if no error
                                                            }
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            },
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'combo',
                            name: 'Product',
                            localId: 'product:combo',
                            label: _('Producto'), // Product label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: {
                                body: {
                                    dataFeed: function (text) {
                                        var vthis = this;
                                        if (text.length > 2) {
                                            // Trigger data fetch if input length is greater than 2
                                            webix
                                                .ajax()
                                                .headers({
                                                    'Content-type': 'application/json',
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'es/Select/GamesCasinoSelect',
                                                    '{"Filter":"' + text + '"}',
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            webix.message('Error! '); // Error message on failure
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            var resp = JSON.parse(text);
                                                            if (!resp.HasError) {
                                                                vthis.parse(resp.Data); // Parse and display data if no error
                                                            }
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            },
                        },
                        {
                            view: 'text',
                            name: 'Name',
                            label: "<span class='icon-user'></span>" + _('Nombre'), // Name label
                            labelPosition: 'top',
                            placeholder: _('Nombre'),
                            invalidMessage: _('Id is required'), // Validation message
                        },
                        {
                            view: 'richselect',
                            name: 'IsActivate',
                            label: "<span class='icon-state'></span>" + _('Estado'), // Status label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                { id: 'null', value: _('Todos') }, // All option
                                { id: 'A', value: _('Activado') }, // Activated option
                                { id: 'I', value: _('Inactivado') }, // Deactivated option
                            ],
                        },
                        {
                            view: 'richselect',
                            name: 'CountrySelect',
                            id: 'CountrySelect',
                            minWidth: 200,
                            localId: 'regions:combo',
                            label: "<span class='icon-language'></span>" + _('País'), // Country label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            on: {
                                onChange: function (data, obj) {
                                    var currentValue = this.getValue();
                                    if (currentValue.length > 0) {
                                        $$('button').enable(); // Enable button if a country is selected
                                    } else {
                                        $$('button').disable(); // Disable button if no country is selected
                                    }
                                },
                            },
                            options: {
                                body: {
                                    template: function (obj) {
                                        return (
                                            "<i class='flags " + obj.icon + "'></i>" + obj.value // Display country flag and name
                                        );
                                    },
                                    data: countries, // Country data
                                },
                            },
                        },
                    ],
                },
            ],
        };

        const left2 = {
            margin: 5,
            minWidth: 100,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'richselect',
                            name: 'IsVerified',
                            label: "<span class='icon-verified_user'></span>" + _('Verificado'), // Verified label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                { id: 'null', value: _('Todos') }, // All option
                                { id: 'A', value: _('Activado') }, // Activated option
                                { id: 'I', value: _('Inactivado') }, // Deactivated option
                            ],
                        },
                        {
                            view: 'richselect',
                            name: 'FilterCountry',
                            label: "<span class='icon-language'></span>" + _('Filtro País'), // Country filter label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                { id: '', value: _('Todos') }, // All option
                                { id: 'A', value: _('Activado') }, // Activated option
                                { id: 'I', value: _('Inactivado') }, // Deactivated option
                            ],
                        },
                        {
                            view: 'text',
                            name: 'FeaturedOrder',
                            type: 'number',
                            label: "<span class='icon-reorder'></span>" + _('Orden Destacado'), // Featured order label
                            labelPosition: 'top',
                            placeholder: _('Orden Destacado'),
                            invalidMessage: _('Máximo is required'), // Validation message
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text',
                            name: 'Maximum',
                            type: 'number',
                            label: _('Máximo'), // Maximum label
                            labelPosition: 'top',
                            placeholder: _('Máximo'),
                            invalidMessage: _('Máximo is required'), // Validation message
                        },
                        {
                            view: 'text',
                            name: 'Minimum',
                            type: 'number',
                            label: _('Mínimo'), // Minimum label
                            labelPosition: 'top',
                            placeholder: _('Mínimo'),
                            invalidMessage: _('Mínimo is required'), // Validation message
                        },
                        {
                            view: 'text',
                            name: 'ProcessingTime',
                            type: 'number',
                            label: "<span class='icon-history'></span>" + _('Tiempo Procesamiento'), // Processing time label
                            labelPosition: 'top',
                            placeholder: _('Tiempo Procesamiento'),
                            invalidMessage: _(
                                'Tiempos Procesamiento is required', // Validation message
                            ),
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'radio',
                            name: 'TypeDevice',
                            label: _('Dispositivo'), // Device type label
                            labelPosition: 'top',
                            value: 3, // Default value
                            options: [
                                {
                                    id: 1,
                                    value: "<span class='icon-phone'></span>", // Phone option
                                },
                                {
                                    id: 2,
                                    value: "<span class='icon-display'></span>", // Display option
                                },
                                { id: 3, value: _('Ambos') }, // Both option
                            ],
                        },
                        { id: 'grav2', gravity: 1 }, // Gravity for layout
                    ],
                },
            ],
        };

        const upper_section = {
            css: 'father-container',
            height: document.body.offsetWidth < 500 ? 370 : 0, // Adjust height based on screen width
            rows: [
                {
                    margin: 10,
                    cols: [left], // Left section
                },
            ],
        };

        const upper_section2 = {
            css: 'father-container',
            height: document.body.offsetWidth < 500 ? 500 : 0, // Adjust height based on screen width
            rows: [
                {
                    margin: 10,
                    cols: [left2], // Left section 2
                },
            ],
        };

        const accordion_section = {
            id: 'b5',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    paddingY: 10,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros Avanzados'), // Advanced filters header
                            body: {
                                padding: 10,
                                rows: [upper_section2], // Upper section 2
                            },
                        },
                    ],
                },
            ],
        };

        const buttons = {
            id: 'b2',
            rows: [
                {
                    margin: 10,
                    responsive: 'b2',
                    cols: [
                        { id: 'grav', gravity: 4 }, // Gravity for layout
                        {
                            view: 'button',
                            value: _('Añadir Producto Partner'), // Add Partner Product button
                            type: 'form',
                            width: screen == 'small' ? 0 : 200,
                            minWidth: 200,
                            hidden: !devConfig.getPermAction(
                                'partnersProductsAdd',
                                'Add', // Check permission for adding partner products
                            ),
                            css: 'prm-partnersProductsAdd',
                            click: () => {
                                this.app.callEvent('addProductPartner:button', [{}]); // Trigger add product event
                            },
                        },
                        {
                            view: 'button',
                            value: _('Limpiar'), // Clear button
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                this.getRoot().clear(); // Clear form fields
                            },
                        },
                        {
                            view: 'button',
                            id: 'button',
                            disabled: true, // Initially disabled
                            value: _('Consultar'), // Consult button
                            type: 'form',
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                const filterdata = this.getRoot().getValues(); // Get form values
                                filterdata.Partner = id_partner; // Add partner ID to filter data
                                this.app.callEvent('partnerProducts:filter', [
                                    filterdata, // Trigger filter event
                                ]);
                                $$('b1').collapse(); // Collapse filters
                                $$('a5').scrollTo(100, 0); // Scroll to a specific position
                            },
                        },
                    ],
                },
            ],
        };

        const accordion_section1 = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Filters header
                            id: 'b1',
                            body: {
                                padding: 10,
                                rows: [
                                    upper_section,
                                    accordion_section,
                                    buttons, // Include buttons
                                ],
                            },
                        },
                    ],
                },
            ],
        };

        return {
            view: 'form',
            type: 'clean',
            rows: [accordion_section1], // Main layout
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view and sets up responsive behavior.
     * @param {Object} grid - The grid object.
     */
    init(grid) {
        webix.ready(function () {
            if (screen.width < 500) {
                $$('grav').hide(); // Hide elements for small screens
                $$('grav2').hide();
            }
        });
    }
}

// FILE DOCUMENTED
